export const LOAN_SUBMISSION_EMAIL_TYPE = {
  CLIENT: 'client',
  LENDER: 'lender',
};
